import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from '../image';

const ProductImage = ({ product, hasMoreProductsPerRow, loading }) => {
  const { altImage, heroImage } = product;
  const [imgSrc, setImgSrc] = useState(heroImage || '');

  function handleMouseOver() {
    if (altImage) {
      setImgSrc(altImage);
    }
  }

  function handleMouseOut() {
    if (altImage) {
      setImgSrc(heroImage);
    }
  }

  return (
    <div
      className="product-list__image-wrapper product-list__image-wrapper--with-lazy-img ar1"
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOut}
    >
      <Image
        className="product-image"
        loading={loading}
        media={{ url: imgSrc }}
        sizes={{
          s: hasMoreProductsPerRow ? '50vw' : '95vw',
          l: hasMoreProductsPerRow ? '33vw' : '45vw',
        }}
        alt={product.imageAlt || product.name}
      />
    </div>
  );
};

ProductImage.defaultProps = {
  hasMoreProductsPerRow: false,
  loading: 'lazy',
};

ProductImage.propTypes = {
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  hasMoreProductsPerRow: PropTypes.bool,
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

export default ProductImage;
